<template>
    <div class="page newpage">
        <div class="_flex_sb" style="height: 380px;">
            <div class="w_30">
                <div class="_flex_sb mt_30">
                    <div>
                        <div class="_color f_16">您好</div>
                        <div class="one_left_name f_30 fw_6 mt_20">{{loginInfo.nick_name}}</div>
                        <div class="mt_20 f_20">{{loginInfo.phone}}</div>
                        <div class="_color mt_20 f_16">{{loginInfo.group_name}}</div>
                    </div>
                    <img style="width: 100px;height: 100px;" v-if="loginInfo.avatar" :src="loginInfo.avatar" />
                    <img style="width: 100px;height: 100px;" v-else src="../../assets/logo_.png" />
                </div>
                <div class="c9 mt_20 f_20">{{businessInfo.title}}</div>
                <div class="c9 mt_20 f_16">{{loginInfo.depart_name}}</div>
                <div class="_flex_sb c9 mt_40 f_16">
                    <div>
                        <div>IP：{{loginInfo.login_ip}}</div>
                        <div class="mt_10">登录：{{loginInfo.login_time}}</div>
                    </div>
                    <a class="fr" :href="locationhref"> 长按拖放至桌面 <br /> 生成快捷方式 </a>
                </div>
            </div>
            <div class="w_50 ml_30 mr_30 bs br_8 p_10">
                <div class="_flex_sb">
                    <div class="_color" style="border-left: 10px solid;padding-left: 10px;height: 20px;">个人业绩排名</div>
                    <div>
                        <el-select v-model="personid" clearable filterable size="small" placeholder="选择员工" @visible-change="selectAdmin" style="margin-right: 10px;;">
                            <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
                        </el-select>
                        <el-date-picker size="small" style="width: 260px;margin-right: 10px;" v-model="persontime" type="daterange" value-format="yyyy-MM-dd"range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                        <el-button size="small" icon="el-icon-refresh" @click="getCountRank" v-loading="rankLoading">刷新</el-button>
                    </div>
                </div>
                <div class="_flex_se mt_10 br_8 p_10 bag_f1">
                    <div class="t_c" v-for="(item, index) in rank" :key="index">
                        <div class="_flex" style="align-items: center;">第<span class="_color f_32 pl_10 pr_10">{{item.rank}}</span>名</div>
                        <div class="">{{item.depart_name}}排名</div>
                    </div>
                </div>
                <div class=" _flex_sb _f_fw mb_10">
                    <div class="t_c mt_20" :class="{'br1se':index%4!=0}" style="width: calc(25% - 1px)" v-for="(item, index) in statistics" :key="index">
                        <div class="f_18">{{item.value}}</div>
                        <div class="mt_10">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="w_20">
                <div class="_color t_c f_16" style="display: flex;justify-content: space-around;">
                    <div class="bag1 br_8 mr_10" style="height: 56px;line-height: 56px;flex: 1;" @click="$router.push('document')">通知公告<span class="red f_8" v-if="unread > 0">NEW</span></div>
                    <div class="bag1 br_8" style="height: 56px;line-height: 56px;flex: 1;" @click="$router.push('document')">知识文档</div>
                </div>
                <div class="mt_20 bs br_8 p_10">
                    <div class="_flex_sb mb_10">
                        <div class="_color" style="border-left: 10px solid;padding-left: 10px;">计划待办</div>
                        <a class="c5" @click="$router.push('schedule')">更多</a>
                    </div>
                    <el-scrollbar style="height: 254px;">
                        <div class="_flex_sb _f_ai bb1sd" style="padding: 10px 0px;" v-for="(item, index) in todoArr" :key="index">
                            <div style="min-width: 30%;align-self:flex-start;">
                                <div class="c9">{{item.date.slice(0, 7)}}</div>
                                <div style="display: flex;font-size: 16px;">
                                    <span v-if="item.is_today" style="background-color: #ff9900;color:#fff;border-radius: 50%;width: 24px;height: 24px;line-height: 24px;text-align: center;">{{item.date.slice(8)}}</span>
                                    <span v-else style="width: 24px;height: 24px;line-height: 24px;text-align: center;">{{item.date.slice(8)}}</span>
                                    <span class="c9" style="margin-left: 6px;">{{item.week}}</span>
                                </div>
                            </div>
                            <div style="flex: 1;display: flex;flex-direction: column;">
                                <div style="display: flex;margin-top: 6px;" v-for="todo in item.lists" :key="todo.todo_id">
                                    <el-checkbox :disabled="finishing" @click.native="finish(todo.todo_id)"></el-checkbox>
                                    <div class="c0" style="margin-left: 6px;" :title="todo.todo_content">{{todo.todo_content.slice(-10)}}</div>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <div class="bs br_8 p_20 mt_10">
            <div class="_flex_sb">
                <el-radio-group v-model="type" size="medium" @input="getOrderRank">
                    <el-radio-button v-for="item in typeMap" :key="item.code" :label="item.code" >{{item.name}}</el-radio-button>
                </el-radio-group>
                <div>
                    <el-date-picker size="small" style="width: 260px;margin-right:10px;" v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-button size="small" icon="el-icon-refresh" @click="getOrderRank" v-loading="chartLoading">刷新</el-button>
                </div>
            </div>
            <div id="myChart" class="mt_10" style="width:100%; height:400px;"></div>
        </div>

        <el-dialog title="通知" :visible="show" width="400px" center destroy-on-close @close="show=false">
            <div class="c9">2024-12-12 11:29</div>
            <div class="mt_5"><span class="_color">单号：</span>SP2948392928</div>
            <div class="mt_5"><span class="_color">流程：</span>订单审核</div>
            <div class="mt_5"><span class="_color">环节：</span>审核2-李大同*2776</div>
            <div class="mt_5"><span class="_color">结果：</span>待审核</div>
            <div class="mt_5"><span class="_color">结果：</span><span class="blue">审核通过</span></div>
            <div class="mt_5"><span class="_color">备注：</span><span class="red">建议带上样品</span></div>
        </el-dialog>

        <el-dialog title="待办事项" :visible="represShow" width="500px" center destroy-on-close @close="represShow=false">
            <el-form label-position="right" label-width="80px" :model="formData">
                <el-form-item label="事项：">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="时间：">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item label="附件：">
                    <div class="_flex _f_ai mt_5">
                        <div class="bag_f1 p_5 pl_10 pr_10 mr_5 br_6 lh_20 cp">
                            样品设计稿.jpg
                            <i class="el-icon-delete"></i>
                        </div>
                        <a class="el-icon-download f_20"></a>
                    </div>
                </el-form-item>
                <div class="ml_80">
                    <el-checkbox v-model="formData.name" style="transform: scale(1.2);"><span class="f_12">已完成</span></el-checkbox>
                </div>
                <div class="ml_80 mt_20">
                    <button class="_button f_16 mr_30 nul">取消</button>
                    <button class="_button f_16 b1s">确定</button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    import { todoLists, todoFinish, crmcountRank, crmorderRank, articleUnread, adminLists } from "../../request/apis.js"
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                locationhref: '',
                todoArr: [],
                todoFinished: false,
                finishing: false,
                time: [],
                type: 0,
                typeMap: [],
                chart: {},
                chartLoading: false,
                unread: 0,
                rankLoading: false,
                rank: [],
                statistics: [],
                personid: '',
                persontime: [],

                name: '',
                list: [],
                show: false,
                represShow: false,
                formData: {
                    name: ''
                },
                adminList: [],
            }
        },
        computed: {
            ...mapGetters(['loginInfo']),
            ...mapGetters(['businessInfo']),
        },
        mounted() {
            this.locationhref = location.href;
            this.todoLists();
            this.getCountRank();
            this.getOrderRank();
            this.getUnread();
        },
        methods: {
            async getUnread(){
                var res = await articleUnread();
                if (res.code == 0) {
                    this.unread = res.data;
                }
            },
            async todoLists() {
                var res = await todoLists({ state: 1 });
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.todoArr = [];
                res.data.forEach(ele => {
                    let exits = this.todoArr.filter(item => item.date == ele.todo_day).length;
                    if (!exits) {
                        this.todoArr.push({ date: ele.todo_day, week: ele.week, is_today: ele.is_today, lists: [ele] });
                    } else {
                        this.todoArr.forEach(el => {
                            if (el.date == ele.todo_day) {
                                el.lists.push(ele);
                            }
                        });
                    }
                });
                console.log('todo', this.todoArr);
            },
            async finish(todo_id) {
                this.finishing = true;
                var res = await todoFinish({ todo_id });
                this.finishing = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.todoLists();
            },
            async getCountRank(){
                this.rankLoading = true;
                var res = await crmcountRank({ time: this.persontime, admin_id: this.personid });
                this.rankLoading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.rank = res.data.rank;
                this.statistics = res.data.statistics;
                this.persontime = res.data.time;
            },
            async getOrderRank(){
                this.chartLoading = true;
                var res = await crmorderRank({ time: this.time, type: this.type });
                this.chartLoading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.time = res.data.time;
                this.type = res.data.type;
                this.typeMap = res.data.typeMap;
                this.chart = res.data.chart;

                var myChart = echarts.init(document.getElementById('myChart'));
                myChart.setOption(this.chart);
            },
            init() {
                var myChart = echarts.init(document.getElementById('myChart'));
                myChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross', crossStyle: { color: '#999' } }
                    },
                    legend: {
                        data: ['订单', '业绩']
                    },
                    xAxis: [{
                        data: ['精英一组黄婷', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    }],
                    yAxis: [{
                        name: '',
                    }],
                    series: [{
                        name: '订单',
                        type: 'bar',
                        data: [ 2, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3 ]
                    },{
                        name: '业绩',
                        type: 'bar',
                        data: [ 26, 59, 90, 264, 287, 707, 1756, 1822, 48.7, 18.8, 6.0, 2.3 ]
                    }]
                });
            },
            async selectAdmin(query){
                if (!query || this.adminList.length) {
                    return false;
                }
                const res = await adminLists({limit: 1000});
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },
        }
    }
</script>

<style scoped>
    .repres_active {
        background-color: #ff9900;
        color: #fff;
        border-radius: 50%;
        padding: 0 1px;
    }

    .statistics_but ._button {
        background-color: #eee;
        color: #000;
    }

    .statistics_but .active {
        background-color: var(--theme-color);
        color: #fff;
    }
    /deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
</style>